import React, { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import H3 from '../Headings/H3Element';
import SvgIcon from '../SvgIcon';
import { useAuth } from 'Utils/Hooks/useAuth';

const Breadcrumbs = (props) => {
  // Get current admin
  const { currentAdmin } = useAuth();

  // Function to check if the user type has access to a specific route
  const hasAccess = (routeUserType) => {
    return currentAdmin?.user_type === routeUserType;
  };
  return (
    <Fragment>
      <Container fluid={true}>
        <div className='page-title'>
          <Row>
            <Col xs='6'>
              <H3>{props.mainTitle}</H3>
            </Col>
            <Col xs='6'>
              <ol className='breadcrumb'>
                <li className='breadcrumb-item'>
                  {hasAccess('ADMIN') && (
                    <Link to={`${process.env.PUBLIC_URL}/dashboard/report/summarize-report`}>
                      <SvgIcon iconId='stroke-home' />
                    </Link>
                  )}
                  {hasAccess('USER') && (
                    <Link to={`${process.env.PUBLIC_URL}/partner/report/summarize-report`}>
                      <SvgIcon iconId='stroke-home' />
                    </Link>
                  )}
                </li>
                <li className='breadcrumb-item'>{props.parent}</li>
                {props.subParent ? <li className='breadcrumb-item'>{props.subParent}</li> : ''}
                <li className='breadcrumb-item active'>{props.title}</li>
              </ol>
            </Col>
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default Breadcrumbs;
